import styled from "@emotion/styled";
import { Tab, Tabs } from "@mui/material";

export const SecondLevelTabs = styled(Tabs)`
  height: 40px;
  min-height: unset;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
`;

export const SecondLevelTab = styled(Tab)`
  text-transform: none;
  min-height: unset;
  font-size: 14px;
`;
